var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNepal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.001C24.8366 32.001 32 24.8375 32 16.001C32 7.16442 24.8366 0.000976562 16 0.000976562C7.16344 0.000976562 0 7.16442 0 16.001C0 24.8375 7.16344 32.001 16 32.001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9057 17.74L31.9053 17.7395L31.9053 17.74H31.9057Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9056 17.74C31.9056 17.7399 31.9057 17.7398 31.9057 17.7395L14.3591 0.0841064C13.5676 0.164794 12.793 0.303169 12.0398 0.494981C5.11862 2.25717 0 16.0009 0 16.0009C0 16.0009 22.3999 30.9906 24.9553 29.2612C25.4666 28.9152 25.9569 28.5404 26.4236 28.1391L16.0247 17.74H31.9056Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8261 16.0009L12.2653 0.440247C5.2305 2.12256 0 8.45043 0 16.0009C0 24.8374 7.1635 32.0009 16 32.0009C19.3518 32.0009 22.4623 30.9696 25.0331 29.2079L11.8261 16.0009H27.8261Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2165 23.6254L13.2625 22.7063L14.303 20.8139L12.1812 21.2198L11.9123 19.0762L10.4343 20.6527L8.95641 19.0762L8.68747 21.2198L6.56566 20.8138L7.60622 22.7063L5.6521 23.6254L7.60622 24.5445L6.56566 26.437L8.6876 26.0311L8.95635 28.1746L10.4343 26.598L11.9123 28.1746L12.1812 26.0311L14.303 26.437L13.2624 24.5446L15.2165 23.6254Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9124 8.87491L12.4911 8.20647L13.2479 6.83004L11.7046 7.12529L11.5091 5.56616L10.4341 6.71285L9.35919 5.56616L9.16356 7.12529L7.62025 6.83004L8.37712 8.20647L6.95581 8.87491L10.4341 9.57066L13.9124 8.87491Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6079 8.875C14.6079 11.1802 12.7391 13.0489 10.4339 13.0489C8.12876 13.0489 6.26001 11.1802 6.26001 8.875",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNepal);
export default __webpack_public_path__ + "static/media/nepal.1a663d42.svg";
export { ForwardRef as ReactComponent };